import { render, staticRenderFns } from "./releaseConfirmation_page.vue?vue&type=template&id=ac0a0bce&scoped=true"
import script from "./releaseConfirmation_page.vue?vue&type=script&lang=js"
export * from "./releaseConfirmation_page.vue?vue&type=script&lang=js"
import style0 from "./releaseConfirmation_page.vue?vue&type=style&index=0&id=ac0a0bce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0a0bce",
  null
  
)

export default component.exports